import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GenericComponentsModule } from '@helios/generic-components'
import {
  NgbAccordionModule,
  NgbModalModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import { DateModule, NfFormsModule, ToggleModule } from '@northfork/ng-basics'
import { AccountDetailsPanelComponent } from './account-details-panel.component'
import { AccountDetailsGridComponent } from './components/account-details-grid/account-details-grid.component'
import { AccountNotesGridComponent } from './components/account-notes-grid/account-notes-grid.component'
import { AggregateDetailsGridComponent } from './components/aggregate-details-grid/aggregate-details-grid.component'
import { NoteModalComponent } from './components/note-modal/note-modal.component'
import { SleeveDetailsGridComponent } from './components/sleeve-details-grid/sleeve-details-grid.component'
import { CustodyContactsModalComponent } from './components/transport-details-grid/custody-contacts-modal/custody-contacts-modal.component'
import { TransportDetailsGridComponent } from './components/transport-details-grid/transport-details-grid.component'

@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    FormsModule,
    GenericComponentsModule,
    ReactiveFormsModule,
    DateModule,
    NfFormsModule,
    NgbModalModule,
    ToggleModule,
    NgbTooltipModule,
    NgbAccordionModule,
  ],
  declarations: [
    AccountDetailsPanelComponent,
    SleeveDetailsGridComponent,
    AggregateDetailsGridComponent,
    NoteModalComponent,
    AccountDetailsGridComponent,
    TransportDetailsGridComponent,
    AccountNotesGridComponent,
    CustodyContactsModalComponent,
  ],
  exports: [AccountDetailsPanelComponent],
})
export class AccountDetailsModule {}

export { AccountDetailsPanelComponent }
